import React from 'react';
import { CLIENT_LOGOS, SECTORS } from '../constants';
import './About.css';

function About() {
  return (
    <div className="about-page">
      {/* Header Spacer */}
      <div className="about-header-spacer"></div>

      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero-container">
          <h1 className="about-hero-title">
            Empowering Women in<br/>Economics & Policy
          </h1>
        </div>
      </section>

      {/* Mission Section */}
      <section className="about-mission">
        <div className="about-mission-container">
          <div className="about-mission-left">
            <div>
              <h2 className="about-mission-title">About Us</h2>
              <p className="about-mission-text-large">
                Women in Econ/Policy was set up in June 2020 by Prerna Kundu and Prashansa Srivastava with the aim of creating a free and inclusive space for women interested in econ, policy & development to learn and grow together.
              </p>
            </div>
            <div className="about-mission-bottom">
              <p className="about-mission-text-small">
                As of August 2021, Women in Econ/Policy (WIEP India Association) is a registered not-for-profit in India (registered as a Section 8 company).
              </p>
              <p className="about-mission-text-small">
                Our vision for the organisation is to disrupt the status quo in favour of a culture of empathy, co-learning, and democratized access to knowledge, industry insights, skills, and people. We aim to be a professional and personal community- to provide support and share learnings. We seek to make economics and economics-adjacent fields more inclusive by highlighting work by women researchers, expanding economics beyond elite colleges and networks, and creating avenues for networking and mentorship.
              </p>
            </div>
          </div>
          
          <div className="about-mission-right">
            {/* Hands Illustration Box */}
            <div className="about-illustration-box">
              <img 
                src="/cover.jpg" 
                alt="Hands Illustration" 
                className="about-illustration-image"
              />
              <div className="about-illustration-overlay"></div>
              <div className="about-illustration-gradient"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="about-team">
        <div className="about-team-container">
          <h2 className="about-team-main-title">Our People</h2>
          
          {/* Board of Advisors */}
          <div className="about-team-section">
            <h3 className="about-team-section-title">Board of Advisors</h3>
            <div className="about-team-grid">
              <a href="https://www.ashoka.edu.in/profile/ashwini-deshpande/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/AshwiniDeshpande.avif" alt="Ashwini Deshpande" />
                </div>
                <h4 className="about-team-member-name">Ashwini Deshpande</h4>
                <p className="about-team-member-role">Professor of Economics and Founding Director of Centre for Economic Data and Analysis (CEDA), Ashoka University</p>
              </a>
              <a href="https://lums.edu.pk/lums_employee/1481" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/HadiaMajid.avif" alt="Hadia Majid" />
                </div>
                <h4 className="about-team-member-name">Hadia Majid</h4>
                <p className="about-team-member-role">Associate Professor, Department of Economics, Lahore University of Management Sciences</p>
              </a>
              <a href="https://www.idinsight.org/person/ruth-levine/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/RuthLevine.avif" alt="Ruth Levine" />
                </div>
                <h4 className="about-team-member-name">Ruth Levine</h4>
                <p className="about-team-member-role">CEO, IDinsight</p>
              </a>
              <a href="https://cprindia.org/people/yamini-aiyar/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/yamini.avif" alt="Yamini Aiyar" />
                </div>
                <h4 className="about-team-member-name">Yamini Aiyar</h4>
                <p className="about-team-member-role">President and Chief Executive, Center for Policy Research</p>
              </a>
              <a href="https://aud.ac.in/faculty/dr-dipa-sinha" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/dipa.avif" alt="Dipa Sinha" />
                </div>
                <h4 className="about-team-member-name">Dipa Sinha</h4>
                <p className="about-team-member-role">Assistant Professor, School of Liberal Studies, Ambedkar University</p>
              </a>
              <a href="https://in.linkedin.com/in/neetishabesra" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/neetisha.avif" alt="Neetisha Besra" />
                </div>
                <h4 className="about-team-member-name">Neetisha Besra</h4>
                <p className="about-team-member-role">Program Manager, John Hopkins India Foundation</p>
              </a>
              <a href="https://dalberg.com/who-we-are/our-leadership/shruti-goyal/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/shruti.jpg" alt="Shruti Goyal" />
                </div>
                <h4 className="about-team-member-name">Shruti Goyal</h4>
                <p className="about-team-member-role">Associate Partner, Dalberg</p>
              </a>
            </div>
          </div>

          {/* Directors */}
          <div className="about-team-section">
            <h3 className="about-team-section-title">Director's Office</h3>
            <div className="about-team-grid">
              <a href="https://ca.linkedin.com/in/prernakundu" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/prerna.avif" alt="Prerna Kundu" />
                </div>
                <h4 className="about-team-member-name">Prerna Kundu</h4>
                <p className="about-team-member-role">Founder & Director</p>
              </a>
              <a href="https://www.linkedin.com/in/riadutta28/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/ria.avif" alt="Ria Dutta" />
                </div>
                <h4 className="about-team-member-name">Ria Dutta</h4>
                <p className="about-team-member-role">Director</p>
              </a>
              <a href="https://www.linkedin.com/in/anahita-karandikar-91412611a/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/anahita.avif" alt="Anahita Karandikar" />
                </div>
                <h4 className="about-team-member-name">Anahita Karandikar</h4>
                <p className="about-team-member-role">Director</p>
              </a>
              <a href="https://www.linkedin.com/in/ahana-raina/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/aahna.avif" alt="Ahana Raina" />
                </div>
                <h4 className="about-team-member-name">Ahana Raina</h4>
                <p className="about-team-member-role">Chief of Staff</p>
              </a>
              <a href="https://www.linkedin.com/in/vatsla-srivastava/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/Vatsla.avif" alt="Vatsla Srivastava" />
                </div>
                <h4 className="about-team-member-name">Vatsla Srivastava</h4>
                <p className="about-team-member-role">Communications</p>
              </a>
            </div>
          </div>

          {/* Young Women in Econ/Policy Program */}
          <div className="about-team-section">
            <h3 className="about-team-section-title">Young Women in Econ/Policy Program</h3>
            <div className="about-team-grid">
              <a href="https://www.linkedin.com/in/saumya-singla-110/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/saumya.avif" alt="Saumya Singla" />
                </div>
                <h4 className="about-team-member-name">Saumya Singla</h4>
                <p className="about-team-member-role">Manager</p>
              </a>
              <a href="https://www.linkedin.com/in/smriti-saini/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/smriti.jpeg" alt="Smriti Saini" />
                </div>
                <h4 className="about-team-member-name">Smriti Saini</h4>
                <p className="about-team-member-role">Manager</p>
              </a>
              <div className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/salonie.avif" alt="Salonie Chawla" />
                </div>
                <h4 className="about-team-member-name">Salonie Chawla</h4>
                <p className="about-team-member-role">Volunteer</p>
              </div>
            </div>
          </div>

          {/* Newsletter Team */}
          <div className="about-team-section">
            <h3 className="about-team-section-title">Newsletter Team</h3>
            <div className="about-team-grid">
              <a href="https://www.linkedin.com/in/ishitabagchi98/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/ishita.avif" alt="Ishita Baghchi" />
                </div>
                <h4 className="about-team-member-name">Ishita Baghchi</h4>
                <p className="about-team-member-role">Curator</p>
              </a>
              <a href="https://www.linkedin.com/in/saumya-singla-110/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/saumya.avif" alt="Saumya Singla" />
                </div>
                <h4 className="about-team-member-name">Saumya Singla</h4>
                <p className="about-team-member-role">Manager, Young WIEP Program</p>
              </a>
              <a href="https://www.linkedin.com/in/smriti-saini/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/smriti.jpeg" alt="Smriti Saini" />
                </div>
                <h4 className="about-team-member-name">Smriti Saini</h4>
                <p className="about-team-member-role">Manager</p>
              </a>
              <a href="https://www.linkedin.com/in/radhika-kaul-710b19b3/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/radhika.avif" alt="Radhika Kaul" />
                </div>
                <h4 className="about-team-member-name">Radhika Kaul</h4>
                <p className="about-team-member-role">Manager, Professional Development</p>
              </a>
            </div>
          </div>

          {/* Alumni */}
          <div className="about-team-section">
            <h3 className="about-team-section-title">Alumni</h3>
            <div className="about-team-grid">
              <a href="https://www.linkedin.com/in/radhika-kaul-710b19b3/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/radhika.avif" alt="Radhika Kaul" />
                </div>
                <h4 className="about-team-member-name">Radhika Kaul</h4>
                <p className="about-team-member-role">Manager</p>
              </a>
              <a href="https://www.linkedin.com/in/dweepobotee-brahma-b7995562/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/Dweepobotee.avif" alt="Dweepobotee Brahma" />
                </div>
                <h4 className="about-team-member-name">Dweepobotee Brahma</h4>
                <p className="about-team-member-role">Chief Editor, WiEPWrite</p>
              </a>
              <a href="https://www.linkedin.com/in/shrutikakade14/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/shrutikakade.jpeg" alt="Shruti Kakade" />
                </div>
                <h4 className="about-team-member-name">Shruti Kakade</h4>
                <p className="about-team-member-role">Organising Committee Member</p>
              </a>
              <a href="https://www.linkedin.com/in/bishnupriya-bagh/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/Bishnupriya.avif" alt="Bishnupriya Bagh" />
                </div>
                <h4 className="about-team-member-name">Bishnupriya Bagh</h4>
                <p className="about-team-member-role">Organising Committee Member</p>
              </a>
              <a href="https://www.linkedin.com/in/fizza-suhel-161834150/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/fizza.jpeg" alt="Fizza Suhel" />
                </div>
                <h4 className="about-team-member-name">Fizza Suhel</h4>
                <p className="about-team-member-role">Organising Committee Member</p>
              </a>
              <div className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/Vasanthi.avif" alt="Vasanthi S Pillai" />
                </div>
                <h4 className="about-team-member-name">Vasanthi S Pillai</h4>
                <p className="about-team-member-role">Design Team Manager</p>
              </div>
              <a href="https://www.linkedin.com/in/manasbipoudel/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/Manasb.avif" alt="Manasbi Poudel" />
                </div>
                <h4 className="about-team-member-name">Manasbi Poudel</h4>
                <p className="about-team-member-role">Organising Committee Member</p>
              </a>
              <a href="https://www.linkedin.com/in/ridhi-aggarwal/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/ridhi.avif" alt="Ridhi Aggarwal" />
                </div>
                <h4 className="about-team-member-name">Ridhi Aggarwal</h4>
                <p className="about-team-member-role">Organising Committee Member</p>
              </a>
              <a href="https://www.linkedin.com/in/sakshi-hallan-093492b3/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/sakshi.avif" alt="Sakshi Hallan" />
                </div>
                <h4 className="about-team-member-name">Sakshi Hallan</h4>
                <p className="about-team-member-role">Organising Committee Member</p>
              </a>
              <a href="https://www.linkedin.com/in/samhita-khuntia-032726a5/" target="_blank" rel="noopener noreferrer" className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/Samhita.avif" alt="Samhita Kuntia" />
                </div>
                <h4 className="about-team-member-name">Samhita Kuntia</h4>
                <p className="about-team-member-role">Organising Committee Member</p>
              </a>
              <div className="about-team-member">
                <div className="about-team-member-image">
                  <img src="/akanksha.avif" alt="Akanksha Sharma" />
                </div>
                <h4 className="about-team-member-name">Akanksha Sharma</h4>
                <p className="about-team-member-role">Communications Intern</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Scale-up Team Section */}
      <section className="about-scaleup-team">
        <div className="about-scaleup-container">
          <h2 className="about-scaleup-main-title">Scale-up Team</h2>
          
          {/* Leadership */}
          <div className="about-scaleup-section">
            <h3 className="about-scaleup-section-title">Leadership</h3>
            <div className="about-scaleup-grid">
              <a href="https://www.linkedin.com/in/ahana-raina/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/aahna.avif" alt="Ahana Raina" />
                </div>
                <h4 className="about-scaleup-member-name">Ahana Raina</h4>
              </a>
              <a href="https://www.linkedin.com/in/prerna-kundu/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/prerna.avif" alt="Prerna Kundu" />
                </div>
                <h4 className="about-scaleup-member-name">Prerna Kundu</h4>
              </a>
              <a href="https://www.linkedin.com/in/ria-dutta/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/ria.avif" alt="Ria Dutta" />
                </div>
                <h4 className="about-scaleup-member-name">Ria Dutta</h4>
              </a>
              <a href="https://www.linkedin.com/in/anahita-karandikar/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/anahita.avif" alt="Anahita Karandikar" />
                </div>
                <h4 className="about-scaleup-member-name">Anahita Karandikar</h4>
              </a>
            </div>
          </div>

          {/* Interns */}
          <div className="about-scaleup-section">
            <h3 className="about-scaleup-section-title">Interns</h3>
            <div className="about-scaleup-grid">
              <a href="https://www.linkedin.com/in/merlin-thomas-ssc/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/merlin.jpeg" alt="Merlin Thomas" />
                </div>
                <h4 className="about-scaleup-member-name">Merlin Thomas</h4>
              </a>
              <a href="https://www.linkedin.com/in/pavani-munnuri-3403041b4/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/pavani.png" alt="Pavani Munnuri" />
                </div>
                <h4 className="about-scaleup-member-name">Pavani Munnuri</h4>
              </a>
            </div>
          </div>

          {/* Collaborators */}
          <div className="about-scaleup-section">
            <h3 className="about-scaleup-section-title">Collaborators</h3>
            <div className="about-scaleup-grid">
              <a href="https://www.linkedin.com/in/aanchal--gupta/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/aanchal.jpeg" alt="Aanchal Gupta" />
                </div>
                <h4 className="about-scaleup-member-name">Aanchal Gupta</h4>
              </a>
              <a href="https://in.linkedin.com/in/yasashvi-paarakh" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/yasashvi.jpeg" alt="Yasashvi Parakh" />
                </div>
                <h4 className="about-scaleup-member-name">Yasashvi Parakh</h4>
              </a>
              <a href="https://www.linkedin.com/in/saumya-singla/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/saumya.avif" alt="Saumya Singla" />
                </div>
                <h4 className="about-scaleup-member-name">Saumya Singla</h4>
              </a>
              <a href="https://www.linkedin.com/in/vatsla-srivastava/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/Vatsla.avif" alt="Vatsla Srivastava" />
                </div>
                <h4 className="about-scaleup-member-name">Vatsla Srivastava</h4>
              </a>
              <a href="https://www.linkedin.com/in/stuti-tomar-35a624297" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/stuti.png" alt="Stuti Tomar" />
                </div>
                <h4 className="about-scaleup-member-name">Stuti Tomar</h4>
              </a>
            </div>
          </div>

          {/* Previous Volunteers */}
          <div className="about-scaleup-section">
            <h3 className="about-scaleup-section-title">Previous Volunteers</h3>
            <div className="about-scaleup-grid">
              <a href="https://www.linkedin.com/in/anushree-srivastava-0b4b54111/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/anushree.jpeg" alt="Anushree Srivastava" />
                </div>
                <h4 className="about-scaleup-member-name">Anushree Srivastava</h4>
              </a>
              <a href="https://www.linkedin.com/in/neelesha-dhawan/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/neelesha.jpeg" alt="Neelesha Dhawan" />
                </div>
                <h4 className="about-scaleup-member-name">Neelesha Dhawan</h4>
              </a>
              <a href="https://www.linkedin.com/in/gowri-natarajan-00276470/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/gowri.jpeg" alt="Gowri Natarajan" />
                </div>
                <h4 className="about-scaleup-member-name">Gowri Natarajan</h4>
              </a>
              <a href="https://www.linkedin.com/in/chaarmikha/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/chaarmikha.jpeg" alt="Chaarmikha Nagalla" />
                </div>
                <h4 className="about-scaleup-member-name">Chaarmikha Nagalla</h4>
              </a>
              <a href="https://www.linkedin.com/in/nayanika-chakraborty/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/nayanika.jpeg" alt="Nayanika Chakraborty" />
                </div>
                <h4 className="about-scaleup-member-name">Nayanika Chakraborty</h4>
              </a>
              <a href="https://www.linkedin.com/in/radhika-kaul/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/radhika.avif" alt="Radhika Kaul" />
                </div>
                <h4 className="about-scaleup-member-name">Radhika Kaul</h4>
              </a>
              <a href="https://www.linkedin.com/in/smriti-saini/" target="_blank" rel="noopener noreferrer" className="about-scaleup-member">
                <div className="about-scaleup-member-image">
                  <img src="/smriti.jpeg" alt="Smriti Saini" />
                </div>
                <h4 className="about-scaleup-member-name">Smriti Saini</h4>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Team Photo Strip */}
      <section className="about-team-photo">
        <img 
          src="/aboutus.jpg" 
          alt="Women in Econ/Policy Team" 
          className="about-team-image"
        />
      </section>
    </div>
  );
}

export default About;


